import React from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import { PartnerPageData, Workflow } from 'types/types'
import { useWorkflowForm } from 'hooks/forms/useWorkflowForm'
import { isWorkflowValid } from 'types/utils'
import {
  getStarSportsColor,
  getStarSportsFont,
  getStarSportsFontStyle,
} from '@/utils/starSportsUtils'
import { parseQuestionType } from '../../src/lib/mappers/question'

export type FormData = {
  [key: string]: string | boolean
}

type DynamicFormProps = {
  workflow: Workflow
  gate: string
  onFormSubmit?: () => void
  gameId: number
  page: PartnerPageData
}

function DynamicForm({ workflow, gate, onFormSubmit, gameId, page }: DynamicFormProps) {
  const { handleSubmit, onSubmit, control, formState, formData } = useWorkflowForm(
    workflow.questions,
    gameId,
    gate,
    onFormSubmit,
  )

  const primaryColor = getStarSportsColor(page)

  return (
    <Box width="100%" maxWidth="500px" sx={{ margin: '0 auto' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2
          style={{
            margin: 0,
            fontFamily: getStarSportsFont(page),
            fontWeight: 'bold',
            textAlign: 'center',
            fontStyle: getStarSportsFontStyle(page),
            color: primaryColor,
          }}
        >
          {workflow?.title?.toUpperCase() ?? ''}
        </h2>
        <Box display="flex" flexDirection="column" justifyContent="left" gap={2} mt={2}>
          {workflow.questions.map((question, index) => (
            <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <div>{parseQuestionType(question, control)}</div>
              {index !== workflow.questions.length - 1 ? <Divider /> : null}
            </Box>
          ))}
          <Button
            variant="contained"
            type="submit"
            sx={{
              height: '50px',
              borderRadius: '8px',
              textTransform: 'none',
            }}
            disabled={
              formState.isSubmitting ||
              !formState.isValid ||
              !isWorkflowValid(workflow.questions, formData)
            }
          >
            <Typography sx={{ color: 'white' }}>Submit</Typography>
          </Button>
        </Box>
      </form>
    </Box>
  )
}

export default DynamicForm
